import type { EVMToken, SwapInfo } from '@endaoment-frontend/types';

import { equalAddress } from './web3';

/**
 * Estimates proceeds from a token swap after fees
 * @param token - The EVM token being swapped
 * @param quote - Quote information from swap
 * @param getStablecoin - Function to get stablecoin for a chain
 * @param equalAddress - Function to compare addresses
 */
export const estimateProceeds = (
  token: EVMToken,
  quote: Pick<SwapInfo['quote'], 'endaomentFee' | 'expectedUsdc' | 'minimumTolerableUsdc'> | undefined,
  getStablecoin: (chainId: number) => EVMToken,
): {
  estimatedUniswapFee: bigint;
  estimatedProceeds: bigint;
  estimatedMinProceeds: bigint;
} => {
  if (!quote) {
    return {
      estimatedUniswapFee: 0n,
      estimatedProceeds: 0n,
      estimatedMinProceeds: 0n,
    } as const;
  }

  // TODO: fee percentage must be changed depending on actual uni fee
  const estimatedUniswapFee = !equalAddress(token.contractAddress, getStablecoin(token.chainId).contractAddress)
    ? (quote.expectedUsdc * 3n) / 1_000n
    : 0n;
  const estimatedProceeds = quote.expectedUsdc - quote.endaomentFee - estimatedUniswapFee;
  const estimatedMinProceeds = quote.minimumTolerableUsdc - quote.endaomentFee - estimatedUniswapFee;

  return {
    estimatedUniswapFee,
    estimatedProceeds,
    estimatedMinProceeds,
  } as const;
};
